import { render, staticRenderFns } from "./Sanciones.vue?vue&type=template&id=a3ee13e0&"
import script from "./Sanciones.vue?vue&type=script&lang=js&"
export * from "./Sanciones.vue?vue&type=script&lang=js&"
import style0 from "./Sanciones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports